import React from 'react';
import PropTypes from 'prop-types';
import { ContentSection } from '~components/Layout';
import StatePageAccordion, {
  AccordionGroup,
} from '~components/common/Accordion/StatePageAccordion';
import Markdown from '~components/common/Markdown';
import {
  howDoIContactMyLocalElectionOffice,
  whoIsInChargeOfMyElections,
} from '~utils/faqAnswersContactsAndReferences';

function StateContactInfo({ state, info }) {
  return (
    <ContentSection width='mid' isZebraStriped>
      <a id='contact-info' aria-hidden='true' />
      <h2 className='mt-0'>Your election officials in {state.name}</h2>

      <AccordionGroup>
        <StatePageAccordion heading='How do I reach my local election office?'>
          <Markdown content={howDoIContactMyLocalElectionOffice(state.code)} />
        </StatePageAccordion>
        <StatePageAccordion
          heading={`Who is in charge of ${state.name} elections?`}
        >
          <Markdown
            content={whoIsInChargeOfMyElections(info, state.name, state.code)}
          />
        </StatePageAccordion>
      </AccordionGroup>
    </ContentSection>
  );
}

StateContactInfo.propTypes = {
  state: PropTypes.object,
  info: PropTypes.object,
};

export default StateContactInfo;
